import { useFormikContext } from 'formik';
import React from 'react';

import styles from './FormErrorMessage.module.scss';

const FormErrorMessageGeneral = React.memo(() => {
  const { errors, touched } = useFormikContext();

  return (
    Object.keys(errors).length > 0 &&
    Object.keys(touched).length > 0 && (
      <div className={styles.errorMessage}>
        <p>Sprawdź pola formularza</p>
      </div>
    )
  );
});

FormErrorMessageGeneral.propTypes = {};

export default FormErrorMessageGeneral;
